type Listener = () => void;

let webhookPanelOpen = false;
const listeners = new Set<Listener>();

export function subscribeToWebhookPanelPersistence(listener: Listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function isWebhookPanelPersistent() {
  return webhookPanelOpen;
}

export function setWebhookPanelPersistent(open: boolean) {
  if (webhookPanelOpen === open) return;
  webhookPanelOpen = open;
  listeners.forEach(listener => listener());
}
